import { ColorScheme } from '@cbhq/cds-common';
import { SelectOption } from '@cbhq/cds-web/controls';
import { Icon } from '@cbhq/cds-web/icons';
import { Box, HStack } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system';
import { Tag } from '@cbhq/cds-web/tag/Tag';
import { TextHeadline } from '@cbhq/cds-web/typography';

import { useAppState } from ':cloud/contexts/AppStateContext';
import { ProjectRoleNEW, ProjectWithRole } from ':cloud/types/service_proto';

type ProjectSelectorOptionProps = {
  minHeight?: number;
  project: ProjectWithRole;
};

const PROJECT_ROLE_CONFIG: Record<
  Exclude<ProjectRoleNEW, ProjectRoleNEW.Unspecified>,
  { colorScheme: ColorScheme; label: string }
> = {
  [ProjectRoleNEW.Owner]: { colorScheme: 'blue', label: 'Owner' },
  [ProjectRoleNEW.Admin]: { colorScheme: 'green', label: 'Admin' },
  [ProjectRoleNEW.UserNEW]: { colorScheme: 'gray', label: 'User' },
};

export function ProjectSelectorOption({ project, minHeight }: ProjectSelectorOptionProps) {
  const { selectedProject } = useAppState();
  const roleConfig =
    project.userRole !== ProjectRoleNEW.Unspecified ? PROJECT_ROLE_CONFIG[project.userRole] : null;

  return (
    <SelectOption
      value={project.id}
      key={project.id}
      title={
        <HStack gap={1.5}>
          <TextHeadline as="span" overflow="truncate">
            {project.name}
          </TextHeadline>
          {roleConfig && <Tag colorScheme={roleConfig.colorScheme}>{roleConfig.label}</Tag>}
        </HStack>
      }
      minHeight={minHeight}
      accessory={project.id === selectedProject?.id ? <SelectOptionAccessory /> : undefined}
    />
  );
}

function SelectOptionAccessory() {
  return (
    <Pressable
      background="backgroundAlternate"
      transparentWhileInactive
      borderRadius="roundedFull"
      as="a"
    >
      <Box spacing={1} alignItems="center" justifyContent="center">
        <Icon name="gear" size="s" color="foreground" />
      </Box>
    </Pressable>
  );
}
